import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import React, { FC } from "react";

import { MaterialType } from "../../../types/materials";
import { BiesseMaterialLogo } from "../../biesse-logo/biesse-material-logo";

export interface MaterialsSliderTitleProps {
  material?: MaterialType;
  className?: string;
}

export const MaterialsSliderTitle: FC<MaterialsSliderTitleProps> = ({ material, className }) => {
  return (
    <div className={clsx("flex items-end mb-8 w-full relative", className)}>
      <AnimatePresence mode="popLayout">
        <motion.div
          key={material}
          transition={{ duration: 0.3 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 100 }}
          exit={{ opacity: 0 }}
        >
          <BiesseMaterialLogo
            material={material}
            className="mb-[1px] [&_path]:!fill-dark h-24 xl:h-28 2xl:h-32 3xl:h-40"
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
